import { createStore, combineReducers, applyMiddleware } from "redux";
import { reducer as formReducer } from "redux-form";
import { reducer as toastrReducer } from "react-redux-toastr";
import promise from "redux-promise";
import multi from "redux-multi";
import thunk from "redux-thunk";
import evaluationReducer from "../components/evaluation/reduxEvaluation/evaluationReducer"
import provider from './reducers/provider'
import { saveLastCity } from '../services/lastCity'

const rootReducer = combineReducers({
  toastr: toastrReducer,
  form: formReducer,
  evaluationReducer: evaluationReducer,
  provider: provider,
});

const devTools =
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = applyMiddleware(thunk, multi, promise)(createStore)(
  rootReducer,
  devTools
);

// Guarda a cidade escolhida sempre que ela muda (home, busca ou modal de cidade).
let lastCity = store.getState().provider.selectedCity
store.subscribe(() => {
  const city = store.getState().provider.selectedCity
  if (city !== lastCity) {
    lastCity = city
    saveLastCity(city)
  }
})

export default store;
